import Y, { useState as $, useContext as de, useEffect as K, createContext as fe } from "react";
import { Grid as g, Button as pe, Paper as me, Divider as he, Spinner as xe } from "@prometheus/components";
import { ModuleDescriptionCard as be, TabWithCounter as C, WorkspaceDetails as ge, LastInteracted as je, TabsNavigationNew as q, BaseContentWrapper as Ee, BaseInfoWrapper as ve, ListHeaderPrimary as Re, BaseEntityContent as ke, SpinnerWidgetContainer as Se } from "@prometheus/features";
import { useNavigate as Te, Routes as _e, Route as R } from "react-router-dom";
import { TypesOfContainer as b } from "@prometheus/enums";
import { setBreadcrumbs as Ce, resetBreadcrumbs as we, getSummary as ye, resetSummary as Oe } from "@prometheus/redux";
import { useDispatch as X, useSelector as Pe } from "react-redux";
import { api as P } from "@prometheus/utils";
var D = { exports: {} }, T = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var H;
function Ae() {
  if (H) return T;
  H = 1;
  var r = Symbol.for("react.transitional.element"), o = Symbol.for("react.fragment");
  function l(f, a, c) {
    var p = null;
    if (c !== void 0 && (p = "" + c), a.key !== void 0 && (p = "" + a.key), "key" in a) {
      c = {};
      for (var i in a)
        i !== "key" && (c[i] = a[i]);
    } else c = a;
    return a = c.ref, {
      $$typeof: r,
      type: f,
      key: p,
      ref: a !== void 0 ? a : null,
      props: c
    };
  }
  return T.Fragment = o, T.jsx = l, T.jsxs = l, T;
}
var _ = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var J;
function Ne() {
  return J || (J = 1, process.env.NODE_ENV !== "production" && function() {
    function r(e) {
      if (e == null) return null;
      if (typeof e == "function")
        return e.$$typeof === ie ? null : e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case S:
          return "Fragment";
        case ee:
          return "Profiler";
        case Q:
          return "StrictMode";
        case oe:
          return "Suspense";
        case se:
          return "SuspenseList";
        case ce:
          return "Activity";
      }
      if (typeof e == "object")
        switch (typeof e.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), e.$$typeof) {
          case O:
            return "Portal";
          case re:
            return (e.displayName || "Context") + ".Provider";
          case te:
            return (e._context.displayName || "Context") + ".Consumer";
          case ne:
            var n = e.render;
            return e = e.displayName, e || (e = n.displayName || n.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
          case ae:
            return n = e.displayName || null, n !== null ? n : r(e.type) || "Memo";
          case L:
            n = e._payload, e = e._init;
            try {
              return r(e(n));
            } catch {
            }
        }
      return null;
    }
    function o(e) {
      return "" + e;
    }
    function l(e) {
      try {
        o(e);
        var n = !1;
      } catch {
        n = !0;
      }
      if (n) {
        n = console;
        var s = n.error, u = typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return s.call(
          n,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          u
        ), o(e);
      }
    }
    function f(e) {
      if (e === S) return "<>";
      if (typeof e == "object" && e !== null && e.$$typeof === L)
        return "<...>";
      try {
        var n = r(e);
        return n ? "<" + n + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function a() {
      var e = A.A;
      return e === null ? null : e.getOwner();
    }
    function c() {
      return Error("react-stack-top-frame");
    }
    function p(e) {
      if (F.call(e, "key")) {
        var n = Object.getOwnPropertyDescriptor(e, "key").get;
        if (n && n.isReactWarning) return !1;
      }
      return e.key !== void 0;
    }
    function i(e, n) {
      function s() {
        z || (z = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          n
        ));
      }
      s.isReactWarning = !0, Object.defineProperty(e, "key", {
        get: s,
        configurable: !0
      });
    }
    function j() {
      var e = r(this.type);
      return U[e] || (U[e] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), e = this.props.ref, e !== void 0 ? e : null;
    }
    function h(e, n, s, u, x, m, M, W) {
      return s = m.ref, e = {
        $$typeof: k,
        type: e,
        key: n,
        props: m,
        _owner: x
      }, (s !== void 0 ? s : null) !== null ? Object.defineProperty(e, "ref", {
        enumerable: !1,
        get: j
      }) : Object.defineProperty(e, "ref", { enumerable: !1, value: null }), e._store = {}, Object.defineProperty(e._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(e, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(e, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: M
      }), Object.defineProperty(e, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: W
      }), Object.freeze && (Object.freeze(e.props), Object.freeze(e)), e;
    }
    function w(e, n, s, u, x, m, M, W) {
      var d = n.children;
      if (d !== void 0)
        if (u)
          if (le(d)) {
            for (u = 0; u < d.length; u++)
              y(d[u]);
            Object.freeze && Object.freeze(d);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else y(d);
      if (F.call(n, "key")) {
        d = r(e);
        var v = Object.keys(n).filter(function(ue) {
          return ue !== "key";
        });
        u = 0 < v.length ? "{key: someKey, " + v.join(": ..., ") + ": ...}" : "{key: someKey}", V[d + u] || (v = 0 < v.length ? "{" + v.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          u,
          d,
          v,
          d
        ), V[d + u] = !0);
      }
      if (d = null, s !== void 0 && (l(s), d = "" + s), p(n) && (l(n.key), d = "" + n.key), "key" in n) {
        s = {};
        for (var I in n)
          I !== "key" && (s[I] = n[I]);
      } else s = n;
      return d && i(
        s,
        typeof e == "function" ? e.displayName || e.name || "Unknown" : e
      ), h(
        e,
        d,
        m,
        x,
        a(),
        s,
        M,
        W
      );
    }
    function y(e) {
      typeof e == "object" && e !== null && e.$$typeof === k && e._store && (e._store.validated = 1);
    }
    var E = Y, k = Symbol.for("react.transitional.element"), O = Symbol.for("react.portal"), S = Symbol.for("react.fragment"), Q = Symbol.for("react.strict_mode"), ee = Symbol.for("react.profiler"), te = Symbol.for("react.consumer"), re = Symbol.for("react.context"), ne = Symbol.for("react.forward_ref"), oe = Symbol.for("react.suspense"), se = Symbol.for("react.suspense_list"), ae = Symbol.for("react.memo"), L = Symbol.for("react.lazy"), ce = Symbol.for("react.activity"), ie = Symbol.for("react.client.reference"), A = E.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, F = Object.prototype.hasOwnProperty, le = Array.isArray, N = console.createTask ? console.createTask : function() {
      return null;
    };
    E = {
      react_stack_bottom_frame: function(e) {
        return e();
      }
    };
    var z, U = {}, B = E.react_stack_bottom_frame.bind(
      E,
      c
    )(), G = N(f(c)), V = {};
    _.Fragment = S, _.jsx = function(e, n, s, u, x) {
      var m = 1e4 > A.recentlyCreatedOwnerStacks++;
      return w(
        e,
        n,
        s,
        !1,
        u,
        x,
        m ? Error("react-stack-top-frame") : B,
        m ? N(f(e)) : G
      );
    }, _.jsxs = function(e, n, s, u, x) {
      var m = 1e4 > A.recentlyCreatedOwnerStacks++;
      return w(
        e,
        n,
        s,
        !0,
        u,
        x,
        m ? Error("react-stack-top-frame") : B,
        m ? N(f(e)) : G
      );
    };
  }()), _;
}
process.env.NODE_ENV === "production" ? D.exports = Ae() : D.exports = Ne();
var t = D.exports;
const Me = (r) => {
  const o = Te();
  return /* @__PURE__ */ t.jsx(t.Fragment, { children: /* @__PURE__ */ t.jsxs(
    be,
    {
      title: "Workspace",
      description: "Your personal workspace is accessible by you only. Use it as a canvas to design and experiment with various assets to be shared and used in collaborative studies.",
      iconName: "workspace",
      onClick: () => o("/workspace"),
      actions: /* @__PURE__ */ t.jsx(
        pe,
        {
          onClick: () => o("/workspace"),
          variant: "outlined",
          name: "save",
          children: "Go to workspace"
        }
      ),
      children: [
        /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
          r.subModules.cohort,
          {
            type: "component",
            name: "home-widget-cohort",
            subModules: r.subModules,
            config: {}
          }
        ) }),
        /* @__PURE__ */ t.jsx(
          g,
          {
            item: !0,
            xs: 12,
            borderTop: "1px solid",
            borderColor: "borderColor.light",
            children: /* @__PURE__ */ t.jsx(
              r.subModules.concept,
              {
                type: "component",
                name: "home-widget-concept-set",
                subModules: r.subModules,
                config: {}
              }
            )
          }
        ),
        /* @__PURE__ */ t.jsx(
          g,
          {
            item: !0,
            xs: 12,
            borderTop: "1px solid",
            borderColor: "borderColor.light",
            children: /* @__PURE__ */ t.jsx(
              r.subModules.analyses,
              {
                type: "component",
                name: "home-widget-analysis",
                subModules: r.subModules,
                config: {}
              }
            )
          }
        )
      ]
    }
  ) });
}, We = (r) => {
  const { name: o } = r;
  return /* @__PURE__ */ t.jsx(t.Fragment, { children: o === "home-workspace" && /* @__PURE__ */ t.jsx(Me, { ...r }) });
}, Ie = {
  entityBreadcrumb: (r) => [
    {
      name: "My workspace",
      path: `${r}`
    }
  ]
}, $e = (r, o, l) => [
  {
    title: /* @__PURE__ */ t.jsx(
      C,
      {
        title: "Data Sources",
        count: o == null ? void 0 : o.datasources,
        status: l
      }
    ),
    value: "data-sources",
    iconName: "dataSources",
    onTabClick: r
  },
  {
    title: /* @__PURE__ */ t.jsx(
      C,
      {
        title: "Documents",
        count: o == null ? void 0 : o.documents,
        status: l
      }
    ),
    value: "documents",
    iconName: "documents",
    onTabClick: r
  }
], De = () => P.get(
  "/workspace/cohorts/list?size=10&page=0&sort=modified.timestamp,desc"
), Ye = () => P.get(
  "/workspace/concept-sets/list?size=10&page=0&sort=modified.timestamp,desc"
), Le = () => P.get(
  "/workspace/analyses/list?size=10&page=0&sort=modified.timestamp,desc"
), Fe = () => P.get(
  "/workspace/analyses-submissions/list?size=10&page=0&sort=modified.timestamp,desc"
), ze = () => Promise.all([
  De().catch((r) => null),
  Le().catch((r) => null),
  Ye().catch((r) => null),
  Fe().catch((r) => null)
]), Ue = ({
  summary: r,
  summaryStatus: o
}) => {
  const l = X(), [f, a] = $("data-sources"), { subModules: c, path: p } = de(
    Z
  ), { entityBreadcrumb: i } = Ie, j = Y.useMemo(
    () => $e(a, r, o),
    [r, o]
  );
  return K(() => (l(Ce(i(p))), document.title = "Prometheus - My Workspace", () => {
    l(we());
  }), []), /* @__PURE__ */ t.jsxs(g, { container: !0, minHeight: "100%", children: [
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 6, md: 6.5, lg: 7, xl: 8, p: 3, pl: 6, children: /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, children: [
      /* @__PURE__ */ t.jsx(ge, {}),
      /* @__PURE__ */ t.jsx(je, { getList: () => ze() })
    ] }) }),
    /* @__PURE__ */ t.jsx(
      g,
      {
        item: !0,
        xs: 6,
        md: 5.5,
        lg: 5,
        xl: 4,
        p: 3,
        pr: 6,
        bgcolor: "backgroundColor.dark",
        children: /* @__PURE__ */ t.jsxs(me, { elevation: 0, sx: { minHeight: 300 }, children: [
          /* @__PURE__ */ t.jsx(q, { secondary: !0, active: f, tabs: j }),
          /* @__PURE__ */ t.jsx(he, {}),
          f === "data-sources" && /* @__PURE__ */ t.jsx(
            c.datasources,
            {
              type: "component",
              name: "widget-info",
              subModules: c,
              path: `/${p}/datasource`,
              config: {
                typeContainer: b.WORKSPACE
              }
            }
          ),
          f === "documents" && /* @__PURE__ */ t.jsx(
            c.documents,
            {
              type: "component",
              name: "widget-info",
              subModules: c,
              path: `/${p}/documents`,
              config: {
                typeContainer: b.WORKSPACE
              }
            }
          )
        ] })
      }
    )
  ] });
}, Be = (r, o) => [
  { title: "Overview", value: "", iconName: "workspace", end: !0 },
  // this is needed to exact match specific path
  {
    title: /* @__PURE__ */ t.jsx(
      C,
      {
        title: "Concept sets",
        status: o,
        count: r == null ? void 0 : r.conceptSets
      }
    ),
    value: "concept-sets",
    iconName: "conceptSets"
  },
  {
    title: /* @__PURE__ */ t.jsx(
      C,
      {
        title: "Cohorts",
        status: o,
        count: r == null ? void 0 : r.cohorts
      }
    ),
    value: "cohorts",
    iconName: "cohort"
  },
  {
    title: /* @__PURE__ */ t.jsx(
      C,
      {
        title: "Analytics",
        status: o,
        count: r == null ? void 0 : r.analyses
      }
    ),
    value: "analyses",
    iconName: "analysis"
  }
], Ge = (r) => {
  const { children: o, summary: l, summaryStatus: f } = r, a = Y.useMemo(
    () => Be(l, f),
    [l, f]
  );
  return /* @__PURE__ */ t.jsxs(Ee, { children: [
    /* @__PURE__ */ t.jsxs(ve, { children: [
      /* @__PURE__ */ t.jsx(Re, { title: "My Workspace", iconName: "workspace" }),
      /* @__PURE__ */ t.jsx(q, { tabs: a, withRouting: !0 })
    ] }),
    /* @__PURE__ */ t.jsx(ke, { children: o })
  ] });
}, Z = fe(null), Ve = (r) => {
  const { path: o, title: l, name: f, storage: a, initStorage: c, rootSettings: p, subModules: i } = r, j = X(), [h, w] = $(p), [y, E] = $(!0), { data: k, status: O } = Pe(
    (S) => S.summary
  );
  return K(() => (p || w({
    rootPath: o,
    rootTitle: l
  }), E(!1), j(ye(b.WORKSPACE)), () => {
    j(Oe());
  }), []), y ? /* @__PURE__ */ t.jsx(Se, { children: /* @__PURE__ */ t.jsx(xe, { size: 32 }) }) : /* @__PURE__ */ t.jsx(Z.Provider, { value: { ...r, rootSettings: h }, children: /* @__PURE__ */ t.jsx(Ge, { summary: k, summaryStatus: O, children: /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(_e, { children: [
    /* @__PURE__ */ t.jsx(
      R,
      {
        index: !0,
        element: /* @__PURE__ */ t.jsx(Ue, { summary: k, summaryStatus: O })
      }
    ),
    /* @__PURE__ */ t.jsx(
      R,
      {
        path: "cohorts/*",
        element: /* @__PURE__ */ t.jsx(
          i.cohort,
          {
            name: "cohorts",
            iconName: "cohorts",
            path: `${o}/cohorts`,
            title: "Cohorts",
            subModules: i,
            initStorage: c,
            storage: a,
            rootSettings: h,
            isMainMenu: !1,
            config: {
              typeContainer: b.WORKSPACE,
              parentId: null
            }
          }
        )
      }
    ),
    /* @__PURE__ */ t.jsx(
      R,
      {
        path: "analyses/*",
        element: /* @__PURE__ */ t.jsx(
          i.analyses,
          {
            name: "analyses",
            iconName: "analyses",
            path: `${o}/analyses`,
            title: "Analyses",
            subModules: i,
            initStorage: c,
            storage: a,
            rootSettings: h,
            isMainMenu: !1,
            config: {
              typeContainer: b.WORKSPACE,
              parentId: null
            }
          }
        )
      }
    ),
    /* @__PURE__ */ t.jsx(
      R,
      {
        path: "concept-sets/*",
        element: /* @__PURE__ */ t.jsx(
          i.concept,
          {
            name: "concept-sets",
            iconName: "concept-sets",
            path: `${o}/concept-sets`,
            title: "Concept sets",
            subModules: i,
            initStorage: c,
            storage: a,
            rootSettings: h,
            isMainMenu: !1,
            config: {
              typeContainer: b.WORKSPACE,
              parentId: null
            }
          }
        )
      }
    ),
    /* @__PURE__ */ t.jsx(
      R,
      {
        path: "documents/*",
        element: /* @__PURE__ */ t.jsx(
          i.documents,
          {
            name: "documents",
            iconName: "documents",
            path: `${o}/documents`,
            title: "Documents",
            subModules: i,
            initStorage: c,
            storage: a,
            rootSettings: h,
            isMainMenu: !1,
            config: {
              typeContainer: b.WORKSPACE,
              parentId: null
            }
          }
        )
      }
    ),
    /* @__PURE__ */ t.jsx(
      R,
      {
        path: "data-sources/*",
        element: /* @__PURE__ */ t.jsx(
          i.datasources,
          {
            name: "data-sources",
            iconName: "data-sources",
            path: `${o}/datasource`,
            title: "Data sources",
            subModules: i,
            initStorage: c,
            storage: a,
            rootSettings: h,
            isMainMenu: !1,
            config: {
              typeContainer: b.WORKSPACE,
              parentId: null
            }
          }
        )
      }
    )
  ] }) }) }) });
}, tt = (r) => {
  const { type: o } = r;
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    !o && /* @__PURE__ */ t.jsx(Ve, { ...r }),
    o === "component" && /* @__PURE__ */ t.jsx(We, { ...r })
  ] });
};
export {
  tt as Workspace
};
//# sourceMappingURL=workspace.js.map
